import "./style.scss";
import {
  auth,
  usersRef,
  dateTimeFormat,
  createElement,
  createTable,
  getUserMap,
  monthOffsetQuery,
  dienstQuery,
  firestorePath2URL,
  userMap,
  clearIcon,
  dienstValidator,
  monthValidator,
  createLoadingSpinner,
} from "../global";
import { doc, getDoc, getDocs, onSnapshot, updateDoc } from "firebase/firestore";
import { User } from "@firebase/auth";

/* START HTML */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const appDiv = document.querySelector<HTMLDivElement>(".entry")!;

appDiv.append("Offen Fahrer: ");
const offenFahrer = createElement("b", { id: "offenFahrer", text: "0", parent: appDiv });
createElement("br", { parent: appDiv });
appDiv.append("Offen Sanitäter: ");
const offenSani = createElement("b", { id: "offenSani", text: "0", parent: appDiv });

const zusatz = createElement("th", { id: "zusatzThis", text: "Zusatz Info", hidden: true });
const tableBody = createTable(["Dienst", "Fahrer", "Sanitäter", "Praktikant", zusatz], appDiv);
const loadingSpinner = createLoadingSpinner(appDiv);
/* END HTML */

const urlParams = new URLSearchParams(window.location.search);
const i = parseInt(urlParams.get("i") ?? "0");

let isFahrer = false;
let isSani = false;
/* let isAdmin = false;
let showDebug = false; */

let user: User;

let lock = true;
let lockPraktikant = true;

let myNameCss = "myName";

//check auth
auth.onAuthStateChanged(async function (u) {
  if (!u) {
    window.location.href = "/login";
    return;
  }
  user = u;
  // User is signed in.
  await getUserMap();
  updateTable();

  const userRef = doc(usersRef, user.uid);
  const snap = await getDoc(userRef);
  if (!snap.exists()) {
    console.error("User document doesnt exist!");
    return;
  }
  isFahrer = snap.data().Fahrer;
  isSani = snap.data().Sani;
  /* isAdmin = snap.data().Admin;
  showDebug = snap.data().showDebug; */

  if ([6493].includes(snap.data().Dienstnummer)) {
    //troll
    myNameCss = "myName troll";
  }
});

async function updateTable() {
  const monthQS = await getDocs(monthOffsetQuery(i));

  //snapshot listener month Document
  onSnapshot(monthQS.docs[0].ref, (monthDoc) => {
    if (!monthDoc.exists()) {
      console.error("month doc doesn't exist");
      return;
    }
    const monthData = monthValidator.parse(monthDoc.data());
    offenFahrer.innerText = monthData.offenFahrer.toString();
    offenSani.innerText = monthData.offenSani.toString();
    lock = monthData.lock;
    lockPraktikant = monthData.lockPraktikant;
  });

  onSnapshot(dienstQuery(monthQS.docs[0].ref), (dienstQS) => {
    for (const dienstDoc of dienstQS.docs) {
      const result = dienstValidator.safeParse(dienstDoc.data());
      if (!result.success) continue;
      const dienstData = result.data;
      const dienst = dateTimeFormat.format(dienstData.Dienst.toDate());

      if (dienstData.Tagdienst && !document.getElementById("tagdienste"))
        createElement("tr", { id: "tagdienste", parent: tableBody }).innerHTML =
          "<th colspan=5>Tagdienste:</th>";

      let tr = document.getElementById(dienstDoc.id);

      if (tr == null) tr = createElement("tr", { id: dienstDoc.id, parent: tableBody });
      else tr.innerHTML = "";

      //Date
      const tdDate = createElement("td", { parent: tr, text: dienst });

      if (user.uid == "wbep0vYgM6duThrz6vHHCqCertv1") {
        tdDate.innerHTML = "";
        createElement("a", {
          href: firestorePath2URL(dienstDoc.ref.path),
          text: dienst,
          parent: tdDate,
        }).target = "_blank";
      }

      //Fahrer
      const tdFahrer = createElement("td", { parent: tr });
      const fahrerB = createElement("b", { parent: tdFahrer });

      if (dienstData.Fahrer != "") {
        const id = dienstData.Fahrer;
        fahrerB.innerText = userMap.get(id) ?? "Error: User not found";

        if (dienstData.Fahrer == user.uid) {
          tdFahrer.className = myNameCss;
          if (!lock) {
            const removeBTN = createElement("button", {
              parent: tdFahrer,
              classes: ["right"],
            });
            removeBTN.onclick = async () => {
              await updateDoc(dienstDoc.ref, { Fahrer: "" });
            };
            createElement("img", { parent: removeBTN, src: clearIcon });
            tdFahrer.appendChild(removeBTN);
          }
        }
      } else {
        tdFahrer.appendChild(document.createTextNode("Nicht Besetzt"));

        if (isFahrer && user.uid != dienstData.Sani && user.uid != dienstData.Praktikant && !lock) {
          const enterBTN = createElement("button", {
            parent: tdFahrer,
            text: "Eintragen",
            classes: ["right"],
          });
          enterBTN.onclick = async () => {
            await updateDoc(dienstDoc.ref, { Fahrer: user.uid });
          };
        }
      }

      //Sani
      const tdSani = createElement("td", { parent: tr });
      const saniB = createElement("b", { parent: tdSani });

      if (dienstData.Sani != "") {
        const id = dienstData.Sani;
        saniB.innerText = userMap.get(id) ?? "Error: User not found";
        saniB.id = id;

        if (dienstData.Sani == user.uid) {
          tdSani.className = myNameCss;
          if (!lock) {
            const removeBTN = createElement("button", {
              parent: tdSani,
              classes: ["right"],
            });
            removeBTN.onclick = async () => {
              await updateDoc(dienstDoc.ref, { Sani: "" });
            };
            createElement("img", { parent: removeBTN, src: clearIcon });
            tdSani.appendChild(removeBTN);
          }
        }
      } else {
        tdSani.appendChild(document.createTextNode("Nicht Besetzt"));

        if (isSani && user.uid != dienstData.Fahrer && user.uid != dienstData.Praktikant && !lock) {
          const enterBTN = createElement("button", {
            parent: tdSani,
            text: "Eintragen",
            classes: ["right"],
          });
          enterBTN.onclick = async () => {
            await updateDoc(dienstDoc.ref, { Sani: user.uid });
          };
        }
      }

      //Praktikant
      const tdPraktikant = createElement("td", { parent: tr });
      const praktikantB = createElement("b", { parent: tdPraktikant });

      if (dienstData.Praktikant != "") {
        const id = dienstData.Praktikant;
        praktikantB.innerText = userMap.get(id) ?? "Error: User not found";

        if (dienstData.Praktikant == user.uid) {
          tdPraktikant.className = myNameCss;
          if (!lock) {
            const removeBTN = createElement("button", {
              parent: tdPraktikant,
              classes: ["right"],
            });
            removeBTN.onclick = async () => {
              await updateDoc(dienstDoc.ref, { Praktikant: "" });
            };
            createElement("img", { parent: removeBTN, src: clearIcon });
            tdPraktikant.appendChild(removeBTN);
          }
        }
      } else {
        tdPraktikant.appendChild(document.createTextNode("Nicht Besetzt"));

        if (
          user.uid != dienstData.Fahrer &&
          user.uid != dienstData.Sani &&
          (!lockPraktikant || (!isSani && (i == 0 || i == 1)))
        ) {
          const enterBTN = createElement("button", {
            parent: tdPraktikant,
            text: "Eintragen",
            classes: ["right"],
          });
          enterBTN.onclick = async () => {
            await updateDoc(dienstDoc.ref, { Praktikant: user.uid });
          };
        }
      }

      if (dienstData.Zusatz != "" && dienstData.Zusatz != null) {
        zusatz.hidden = false;
        createElement("td", { text: dienstData.Zusatz, parent: tr });
      }
    }
    if (loadingSpinner) loadingSpinner.remove();
  });
}
